import React from "react";
import { connect } from "react-redux";
import getMemberBasicProfile from "../../../../../_selectors/profileSelectors/getMemberBasicProfile";
import BasicDetail from "../../../../Profile/Home/ProfileInformation/Basic/BasicDetail";
import getMemberBirthPlace from "../../../../../_selectors/profileSelectors/getMemberBirthPlace";
import { updateObject } from "../../../../../_utils";
import getMemberAddress from "../../../../../_selectors/profileSelectors/getMemberAddress";
const Basic = ({ userProfile, showToast, birthPlace, address }) => {
  return (
    <BasicDetail
      userProfile={updateObject(userProfile, { birthPlace, address })}
      showEdit={false}
      hideTitle
    />
  );
};

const mapStateToProps = (state, ownProps) => ({
  userProfile: getMemberBasicProfile(state),
  birthPlace: getMemberBirthPlace(state),
  address: getMemberAddress(state)
});

export default connect(mapStateToProps)(Basic);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileInformation/Basic/index.js